const transformToUpdateAllergenIncludedIngredientsDetailsArgs = data =>
  data?.allergenIncludedIngredientIds

export default transformToUpdateAllergenIncludedIngredientsDetailsArgs
